/**
 * This enum is used for user settings download usage report date.
 */
export enum UserSettingsEnum {
  DATE_FORMAT = 'MM/dd/YYYY',
}
